import { useEffect, useState } from 'react';

const useWindowSize = () => {
    const [screenWidth, setScreenWidth] = useState(0);
  
    useEffect(() => {
      const handleResize = () => setScreenWidth(document.body.offsetWidth);
  
      handleResize();
  
      window.addEventListener("resize", handleResize);
  
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);
  
    return screenWidth;
};

export default useWindowSize;